// extracted by mini-css-extract-plugin
export default {"container":"FormPage_container__srNh1"};